import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  makeListingFullAddressString,
} from 'common/listingHelpers';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import branch from 'client/core/branch';
import log from 'client/lib/log';
import postWithState from 'client/actions/postWithState';

import {
  SR_API_ACTION_HOUSEHOLD_NOTE_SHARE,
} from 'api/actionTypes';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrCreateNoteForm from 'client/components/SrCreateNoteForm';
import SrNotesList, {
  SR_HOUSEHOLD_NOTES,
} from 'client/components/SrNotesList';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';

@branch({
  currentUser: ['currentUser'],
})
class SrHouseholdNotesContainer extends Component {
  static propTypes = {
    household: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    reloadDataTable: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    openedInModal: PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      shareHouseholdNote: null,
    };
  }

  componentDidMount() {
    const { household } = this.props;
    if (!household) {
      const error = new Error(
        'Trying to render a `SrHouseholdNotesContainer` without an active household.'
      );
      error.name = 'SrHouseholdNotesContainerWithoutActiveHouseholdError';
      log.error(error);
    }
  }

  _onClickShareNote = (householdNote) => {
    this.setState({
      shareHouseholdNote: householdNote,
    });
  }

  _onClose = () => {
    this.setState({
      shareHouseholdNote: null,
    });
  }

  _onSubmit = (formValues) => {
    const {
      dispatch,
      reloadDataTable,
    } = this.props;

    const {
      shareHouseholdNote,
    } = this.state;

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_NOTE_SHARE,
      payload: {
        householdNoteId: shareHouseholdNote.id,
        listingIds: formValues.listingIds,
      },
    }).then(() => {
      reloadDataTable();
      this._onClose();
    });
  }

  render() {
    const {
      household,
      dispatch,
      reloadDataTable,
      currentUser,
      openedInModal,
    } = this.props;

    const {
      shareHouseholdNote,
    } = this.state;

    const listings = household.listingApplications.map(({ listing }) => listing);

    const formField = {
      id: 'listingIds',
      type: 'multiple_choice',
      properties: {
        multipleSelection: true,
        useArrayValues: true,
        toggleSingleSelection: true,
        choices: listings.map((listing) => {
          return {
            label: makeListingFullAddressString(listing),
            value: listing.id,
          };
        }),
      },
      validations: ['required'],
    };

    return (
      <div className='SrHouseholdNotesContainer'>
        {household && (
          <div>
            <SrNotesList
              type={SR_HOUSEHOLD_NOTES}
              notes={household.notes}
              dispatch={dispatch}
              reloadDataTable={() => reloadDataTable()}
              currentUser={currentUser}
              openedInModal={openedInModal}
              onClickShareNote={this._onClickShareNote}
            />
            <SrCreateNoteForm
              householdId={household.id}
              dispatch={dispatch}
              reloadDataTable={() => reloadDataTable()}
            />
          </div>
        )}

        {shareHouseholdNote && (
          <SrModalV2
            showCloseButton={false}
            contentMaxWidth='555px'
          >
            <Formik
              onSubmit={this._onSubmit}
              initialValues={createInitialValues({
                formFields: [formField],
                defaultValues: {
                  listingIds:shareHouseholdNote.householdSharedListingNotes.map(({ listingId }) => listingId),
                },
              })}
              validate={createFormValidationFn([formField])}
              render={(formikBag) => (
                <SrBox
                  bgColor='white'
                  borderRadius='24px'
                  padding='28px 25px 30px'
                >
                  <Form>
                    <SrBox>
                      <SrText
                        font='greycliff'
                        weight='800'
                        size='28'
                        lineHeight='34px'
                      >
                        Select Listing to Share Note
                      </SrText>
                    </SrBox>
                    <SrGridRow autofit autofitMinColumnWidth='300px'>
                      <SrFormikField
                        formikBag={formikBag}
                        formField={formField}
                        theme={SR_FIELD_THEME_ADOBE}
                      />
                    </SrGridRow>
                    <SrFlex marginTop='35px' gap='33px' justify='between'>
                      <SrBox width='100%'>
                        <SrButton
                          onClick={this._onClose}
                          theme={SR_BUTTON_THEME_ADOBE_GREY}
                        >
                          Cancel
                        </SrButton>
                      </SrBox>
                      <SrBox width='100%'>
                        <SrButton
                          type='submit'
                          theme={SR_BUTTON_THEME_ADOBE_BLUE}
                        >
                          Submit
                        </SrButton>
                      </SrBox>
                    </SrFlex>
                  </Form>
                </SrBox>
              )}
            />
          </SrModalV2>
        )}
      </div>
    );
  }
}

SrHouseholdNotesContainer.displayName = 'SrHouseholdNotesContainer';

export default SrHouseholdNotesContainer;
